export default "__VITE_ASSET__93679190__"